import { render } from "./MenuDynamic.vue?vue&type=template&id=787f11f5&scoped=true"
import script from "./MenuDynamic.vue?vue&type=script&lang=js"
export * from "./MenuDynamic.vue?vue&type=script&lang=js"

import "./MenuDynamic.vue?vue&type=style&index=0&id=787f11f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787f11f5"]])

export default __exports__